/** AR02 copy (one group per control; a ticket edits only its own file). */
export const ar02PtBr = {
  title: 'Receita reconhecida no período',
  description:
    'Lançamentos de reconhecimento vencidos comparados aos lançamentos contábeis efetivos do livro.',
  prerequisite: '',
  reasons: {
    MISSING_POSTING: 'Lançamento vencido sem contabilização efetiva no livro.',
    POSTING_EVIDENCE_MISMATCH:
      'Receita contabilizada com valor, conta ou vínculo diferente do lançamento do cronograma.',
    REVERSED_POSTING: 'Lançamento revertido neste período, sem correção.',
    COVERAGE_LIMIT:
      'Evidência de reversão, câmbio ou plano de contas insuficiente para confirmar a contabilização.',
    UNPOSTABLE_SCHEDULE:
      'Cronograma sem condições de contabilizar (sem conta de receita, cobertura deste livro ou moeda suportada).',
    OPEN_RECOGNITION_EXCEPTION: 'Exceção de geração do cronograma em aberto para esta competência.',
  },
};

export const ar02En: typeof ar02PtBr = {
  title: 'Revenue recognized in the period',
  description: "Due recognition entries compared with the book's effective journal entries.",
  prerequisite: '',
  reasons: {
    MISSING_POSTING: 'Due entry with no effective posting in this book.',
    POSTING_EVIDENCE_MISMATCH:
      'Posted revenue amount, account, or source link differs from the schedule entry.',
    REVERSED_POSTING: 'Entry reversed this period, with no correction.',
    COVERAGE_LIMIT:
      'Reversal, currency conversion, or chart evidence is insufficient to confirm the posting.',
    UNPOSTABLE_SCHEDULE:
      'Schedule cannot post (no revenue account, no coverage for this book, or unsupported currency).',
    OPEN_RECOGNITION_EXCEPTION: 'Open schedule-generation exception for this competency.',
  },
};
